/* global jQuery */

jQuery(function () {
  // Testimonial carousel functionality
  var TestimonialCarousel = (function () {
    var currentTestimonial = 0
    var testimonials = jQuery('.testimonial')
    var dots = jQuery('.testimonial-dots .dot')
    var totalTestimonials = testimonials.length
    var interval = null

    function showTestimonial (index) {
      // Hide all testimonials
      testimonials.removeClass('active')
      dots.removeClass('active')

      // Show selected testimonial
      jQuery(testimonials[index]).addClass('active')
      jQuery(dots[index]).addClass('active')

      currentTestimonial = index
    }

    function nextTestimonial () {
      var next = (currentTestimonial + 1) % totalTestimonials
      showTestimonial(next)
    }

    function startAutoRotation () {
      interval = setInterval(nextTestimonial, 5000) // 5 seconds
    }

    function stopAutoRotation () {
      if (interval) {
        clearInterval(interval)
        interval = null
      }
    }

    return {
      init: function () {
        if (testimonials.length > 0) {
          // Set up dot click handlers
          dots.on('click', function () {
            var dotIndex = parseInt(jQuery(this).data('dot'))
            showTestimonial(dotIndex)
            stopAutoRotation()
            startAutoRotation() // Restart auto rotation
          })

          // Start auto rotation
          startAutoRotation()

          // Pause on hover
          jQuery('.testimonial-section').on('mouseenter', stopAutoRotation)
          jQuery('.testimonial-section').on('mouseleave', startAutoRotation)
        }
      }
    }
  })()

  // Initialize testimonial carousel
  TestimonialCarousel.init()
})
